import React, {FC, memo} from "react";
import {Root} from "./PreviewElement-styles";
import {PreviewElementProps} from "./PreviewElement-types";


const PreviewElement: FC<PreviewElementProps> = memo((props) => {
    const {baseHeight, image, parameters, children} = props;

    return (
        <Root $baseHeight={baseHeight} $image={image} $parameters={parameters}>
            {children}
        </Root>
    )
});

export default PreviewElement;
